
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StatesDetail, CityDetail, CountryDetail, QuestionDetail } from '@externalregistrationmodel/Registration';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class ExternalRegistrationService {
  private baseUrl: string;
  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {
    //this.baseUrl = environment.Userservicebaseurl;
    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
  }

  // Method to get the state list
  GetState(): Observable<any[]> {
    return this.http.get(this.baseUrl + `/api/Getstate`).pipe(
      map(response => response as StatesDetail[]),
      catchError(handleError),);
  }

  // Method to get the city list
  GetCity(SelectedStateID): Observable<any[]> {
    return this.http.get(this.baseUrl + `/api/GetCities/` + SelectedStateID).pipe(
      map(response => response as CityDetail[]),
      catchError(handleError),);
  }

  // Method to get the Security Question list
  GetQuestion(): Observable<any[]> {
    return this.http.get(this.baseUrl + `/api/GetSecurityQuestion`).pipe(
      map(response => response as QuestionDetail[]),
      catchError(handleError),);
  }

  SaveRegistration(RegistrationModel: any): Observable<any[]> {
    // debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/SaveRegistration`, JSON.stringify(RegistrationModel), options).pipe(
      map(response => response as any));
  }


    getCountries(): Observable<any[]> {
    return this.http.get(this.baseUrl + `/api/GetCountry `).pipe(
    map(response => response as CountryDetail[]),
    catchError(handleError),);
  }
}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);

  // throw an application level error
  return observableThrowError(errorMsg);
}
